import { scaleLinear, scaleSymlog } from 'd3-scale'
import { Margins } from '../../lib/types'
import { ScaleInfo, ChallengesMap, ChallengeInfo } from './types'

export const DOT_RADIUS = 2.5
export const ACTIVE_DOT_RADIUS = 14
export const TICKS_COUNTER = 20
export const LABEL_TICKS_COUNTER = 4
export const HANDLE_AXIS_RADIUS = 8
export const UNDERGROUND_BAR_WIDTH = 2
export const DRAGGABLE_BAR_WIDTH = 2
export const DRAGGING_HANDLE_AXIS_RADIUS = 21
export const DRAGGING_HANDLE_AXIS_RADIUS_MOBILE = 20
export const SPACE_BETWEEN_AXIS_AND_SCATTER_AREA = 32
export const SPACE_BETWEEN_AXIS_AND_AXIS_LABEL = 17
export const TICK_LENGHT = 3

export const ANIMATION_DURATION_SEC = 0.3

export const MARGINS: Margins = {
  top: 35,
  right: 30,
  bottom: 70,
  left: 90,
}

export const SCALES: ScaleInfo = {
  linear: {
    function: scaleLinear,
    ariosity: { x: { min: 0.1, max: 0.1 }, y: { min: 0.1, max: 0.1 } },
  },
  symlog: {
    function: scaleSymlog,
    ariosity: { x: { min: 0.1, max: 0.1 }, y: { min: 0.1, max: 0.1 } },
  },
}

export const CHALLENGES: ChallengesMap<ChallengeInfo> = {
  // NOTE: Order is important (Yes you are right, object shouldn't be ordered!)
  electricity: { isActive: true, name: 'Electricity' },
  transport: { isActive: true, name: 'Transportation' },
  manufacturing: { isActive: true, name: 'Manufacturing' },
  buildings: { isActive: true, name: 'Buildings' },
  agriculture: { isActive: true, name: 'Agriculture' },
}

export const GEO_FILTER = { columnName: 'region_name', name: 'Filter by continent' }

export const CUTOFF_ID = 'cut-off'
export const ARROW_MARKER_ID = 'arrow'
export const CIRCLE_SHADOW_ID = 'circle-shadow'
export const LABEL_SHADOW_ID = 'label-shadow'

export const COUNTRY_LABEL_RECT_HEIGHT = 22
export const XY_LABEL_RECT_HEIGHT = 30

export const MAX_ACTIVE_COUNTRIES = 5

export const UNKNOWN_DATUM_LABEL = 'N/A'
